// extracted by mini-css-extract-plugin
export var mainContent = "layout-main-module--main-content--Ein-n";
export var wrapper = "layout-main-module--wrapper--BBuxH";